import { useDisclosure } from "@chakra-ui/hooks"
import Card from "components/card/custom";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader , PopoverArrow } from "@chakra-ui/react";
import { Portal } from '@chakra-ui/portal'
import {
  Modal,
  ModalBody,
  ModalOverlay,
  ModalHeader
} from "@chakra-ui/modal";
import DivLoader from "components/divloader/DivLoader";
import { useEffect, useState, useContext, useMemo } from "react";
import { MdCircle, MdIntegrationInstructions, MdShoppingCartCheckout } from "react-icons/md";
import {
  MdHighlightOff,
} from "react-icons/md";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import './OrderSummary.css'; // Add your CSS file here
import { SketchPicker } from "react-color";
import bm2payLogo from "../../../../assets/img/bm2pay.svg";
import lightningChecksLogo  from "../../../../assets/img/mainlogo.png";
import paxumLogo  from "../../../../assets/img/paxum.png";
import sampleImage  from "../../../../assets/img/payment-clients/placeholder.png";
import toast from "react-hot-toast";
import { createUpdateCheckout, getCheckOutDetails, updateCheckoutStatus } from "api/clients";
import ShortTruncateCopy from "components/common/RegistrationLinkCopy";
import InputField from "components/fields/InputField";
const smart_routingimg = require("../../../../assets/svg/smart_routing.svg");

const CheckoutProductClientModal = ({
  id,
  secret,
  fetchClients,
  assigned_payment_methods,
  infoData,
}: {
  id: string;
  secret: string;
  fetchClients: () => void;
  assigned_payment_methods?: any;
  infoData?: any;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = useState<boolean>();
  const [initialLoading, setInitialLoading] = useState<boolean>(false);
  
  const [clientData, setClientData]= useState(infoData.row.original);
  const [brandColor, setBrandColor] = useState('rgba(32, 32, 228, 1)');
  const [isCustom, setIsCustom] = useState(false);
  const [style, setStyle] = useState("rounded");
  const [selectedFont, setSelectedFont] = useState("'Poppins'");
  const [showPreview,setShowPreview] = useState(true);
  const [successPreview,setSuccessPreview] = useState(false);
  const [pendingPreview,setPendingPreview] = useState(false);
  const [failedPreview,setFailedPreview] = useState(false);
  const [isCheckoutEnabled,setIsCheckoutEnabled] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState<string>("USD");
  const [amount, setAmount] = useState(null);
  const [paymentLink, setPaymentLink] = useState("");
  const [checkoutId, setCheckoutId] = useState("");
  const [targetDateTime, setTargetDateTime] = useState(null);
  const [businessName,setBusinessName] = useState("Business Name");
  const [imagePreview, setImagePreview] = useState(sampleImage);
  const [base64Image, setBase64Image] = useState("");
  const [checkOutStatus,setCheckOutStatus] = useState(infoData.row.original.is_checkout_enabled || false);
  const [currentActive, setCurrentActive] = useState(1);
  const [isClose,setIsClose] = useState(false);
  const [isCloseModal, setIsCloseModal] =  useState<boolean>(false);

  const ClientLink = "https://"+window.location.hostname+ "/checkout/"+id+"/"+secret;

  const [generatedLink,setGeneratedLink] = useState(ClientLink)

  const [primaryColor, setPrimaryColor] = useState('#2020e4');
  const [secondaryColor, setSecondaryColor] = useState('#422AFB');
  const [buttonColor, setButtonColor] = useState('#5757ac');
  const [showPrimaryPicker, setShowPrimaryPicker] = useState(false);
  const [showSecondaryPicker, setShowSecondaryPicker] = useState(false);
  const [showButtonPicker, setShowButtonPicker] = useState(false);


  const handleClose = () => {
    setIsCloseModal(true)
    setTimeout(() => {
        setIsCloseModal(false)
        onClose();
        setIsClose(true);
        setCurrentActive(1);
        if(!clientData?.checkout_id) {
          setBusinessName("Business Name")
          setImagePreview(sampleImage)
          setBase64Image("")
          setCheckOutStatus(false)
          setSelectedFont("Poppins")
          setShowPreview(true)
          setSuccessPreview(false)
          setPendingPreview(false)
          setFailedPreview(false)
          setIsCheckoutEnabled(false)
          setBrandColor('#2020e4')
          setPrimaryColor('#2020e4')
          setButtonColor('#5757ac')
          setSecondaryColor('#422AFB')
          setIsCustom(false)
          setStyle("rounded")
        } 
    }, 300);
    
  };

  const fetchCheckout = () => {
    if(clientData?.checkout_id) {

      setInitialLoading(true)

      getCheckOutDetails(clientData?.checkout_id,clientData?.client_id,clientData?.client_secret)
        .then((checkoutData) => {
            const responseData = checkoutData?.data;
            const targetDateFromAPI = new Date(responseData?.expires_at);
            if (responseData?.brand_color) {
                setBrandColor(responseData.brand_color);
            }
            if (responseData?.primary_color) {
                setPrimaryColor(responseData.primary_color);
            }
            if (responseData?.button_color) {
                setButtonColor(responseData.button_color);
            }
            if (responseData?.secondary_color) {
                setSecondaryColor(responseData.secondary_color);
            }
            if (responseData?.brand_style) {
                setStyle(responseData.brand_style);
            }
            if (responseData?.brand_font) {
                setSelectedFont(responseData.brand_font);
            }
            if (responseData?.currency) {
                setSelectedCurrency(responseData.currency);
            }
            if (responseData?.amount) {
              setAmount(responseData?.amount)
            }
            if (responseData?.business_name) {
                setBusinessName(responseData.business_name);
            }
            if (responseData?.business_logo) {
                setImagePreview("data:image/jpeg;base64,"+responseData.business_logo);
                setBase64Image(responseData.business_logo);
            }
            setIsCheckoutEnabled(responseData.is_checkout_enabled);
            if(responseData.is_checkout_enabled) {
              setCheckOutStatus(true);
            }
            setTargetDateTime(targetDateFromAPI)
            setInitialLoading(false)
        })
        .catch((error) => {
          toast.error("Something went wrong while fetching checkout Data");
          setInitialLoading(false)
        });
    }
  }

  const handleBusinessChange = (e : any) => setBusinessName(e.target.value);
  const handleStyleChange = (e : any) => setStyle(e.target.value);
  const handleFontChange = (e : any) => setSelectedFont(e.target.value);

  const getBorderRadiusClass = () => {
    if (style === "sharp") {
      return "rounded-none";
    } else if (style === "pill") {
      return "rounded-[25px]";
    } else {
      return "rounded-[10px]";
    }
  };

  const handleFormSubmit = () => {
    const payload = {
      "brand_color" : brandColor,
      "brand_style" : style,
      "brand_font" : selectedFont,
      "status" : isCheckoutEnabled,
      "business_name" : businessName,
      "business_logo" : base64Image,
      "primary_color" : primaryColor,
      "secondary_color" : secondaryColor,
      "button_color" : buttonColor,
    }

    setIsLoading(true);

    createUpdateCheckout(payload,clientData.client_id,clientData.client_secret)
    .then((response) => {
      setIsLoading(false);
      fetchClients()
      toast.success(response?.message);
      setCheckoutId(response?.data?.id);
      handleClose();
      // setTimeout(() => {
      //   setIsLoading(false);
      // }, 2000);
    }).catch((err) => {
      toast.error(
        err?.response?.data?.message ??
          "Failed to update the checkout configurations"
      );
      // setTimeout(() => {
        setIsLoading(false);
      // }, 2000);
    });
    
  }

  const handleToggle = () => {
    setIsCheckoutEnabled(!isCheckoutEnabled);
    const payload = {
      "status" : !isCheckoutEnabled
    }
    setCurrentActive(1);
    setSuccessPreview(false)
    setPendingPreview(false)
    setFailedPreview(false)
    setIsLoading(true);

    updateCheckoutStatus(payload,clientData.client_id,clientData.client_secret)
    .then((response) => {
      setCheckOutStatus(!checkOutStatus);
      setIsLoading(false);
      // toast.success(response?.message);
      // handleClose();
    })
    .catch((error) => {
  });
  }; 

  const handleFileChange = (e:any) => {
    const file = e.target.files[0];
    if (!file) return;
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif"];
    const maxSize = 1 * 1024 * 1024;

    if (!allowedTypes.includes(file.type)) {
      toast.error("Only JPEG, JPG, PNG, and GIF files are allowed.");
      e.target.value = "";
      // setImagePreview(null);
      return;
    } else if (file.size > maxSize) {
      toast.error("File size must be less than or equal to 1 MB.");
      e.target.value = "";
      // setImagePreview(null);
      return;
    } else {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        const base64 = reader.result as string;
        setImagePreview(base64);
        setBase64Image(base64.split(",")[1]);
      };
    }

    // if (file) {
    //   const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif"];
    //   if (allowedTypes.includes(file.type)) {
    //     const reader : any = new FileReader();
    //     reader.readAsDataURL(file);
    //     reader.onloadend = () => {
    //       setImagePreview(reader.result);
    //       setBase64Image(reader.result.split(",")[1]); // Store Base64 (without prefix)
    //     };
    //   } else {
    //     toast.error("Only JPEG, JPG, PNG, and GIF files are allowed.");
    //     e.target.value = "";
    //     setImagePreview(null);
    //   }
    // }
  };

  return (
    <>
      <Popover trigger="hover" placement="bottom">
        <PopoverTrigger>
          <button className="text-blue-500 outline-none">
            <MdShoppingCartCheckout
              className="h-5 w-5 cursor-pointer"
              onClick={() => {
                fetchCheckout()
                onOpen();
              }}
            />
          </button>
        </PopoverTrigger>  
        {/* <Portal >  */}
          <PopoverContent borderColor='blue.800' className="z-20 dark:bg-gray-800 shadow  invisible inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:border-gray-600 dark:bg-gray-800 p-3 border-6 shadow !bg-gray-700">
            <PopoverHeader>
              <span className="text-sm  font-bold text-white">
            Configure Client Checkout
            </span>
            </PopoverHeader>
            <PopoverArrow  className="border h-8 w-8 border-gray-700 !bg-gray-700  "  />
          </PopoverContent>
        {/* </Portal> */}
      </Popover> 
      
      <Modal isOpen={isOpen} onClose={handleClose}>
        <ModalOverlay className="bg-[#000] !opacity-30" />
        <Card extra={`fixed top-0 right-0 h-full rounded-none max-w-[700px] sm:w-full flex flex-col justify-start !z-[1004] overflow-y-auto scrollbar-hide overflow-auto ${isOpen && !isCloseModal ? "card-enter" : "card-exit"}`}>
         <ModalHeader className="py-[20px] mb-[20px] px-[30px] text-2xl font-bold bg-brand-500 text-white">
              <MdHighlightOff className="absolute right-7 top-6 h-8 w-8 cursor-pointer text-white" onClick={handleClose}/>
              Checkout Configurations
          </ModalHeader>
          <ModalBody className="py-3 px-5">
            {initialLoading ? (
              <div className="mt-5 pt-5">
                  <DivLoader className="m-5 h-6 w-6 border-indigo-500" />
                  <p className="text-center">Loading, please wait...</p>
              </div>
            ) : (
              <>
                <div className="flex items-center justify-between mb-4">
                  <div className="flex-1">
                    {checkOutStatus && generatedLink && (
                      <ShortTruncateCopy info={generatedLink} showCopy={true} />
                    )}
                  </div>
                  <label className="relative inline-flex cursor-pointer items-center ml-4 shrink-0">
                    <input
                      type="checkbox"
                      className="peer sr-only"
                      checked={isCheckoutEnabled}
                      onChange={handleToggle}
                    />
                    <div className="peer h-6 w-11 rounded-full bg-gray-400 
                      after:absolute after:left-[2px] after:top-[4px] after:h-5 after:w-5 
                      after:rounded-full after:border after:border-gray-300 after:bg-white 
                      after:transition-all after:content-[''] 
                      peer-checked:bg-indigo-600 peer-checked:after:translate-x-full 
                      peer-checked:after:border-white 
                      peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-400
                      dark:border-gray-600 dark:bg-gray-700 dark:peer-focus:ring-indigo-800"
                    />
                    <span className="ml-3 text-lg font-medium text-gray-900 dark:text-gray-300">
                      {isCheckoutEnabled ? "Enabled" : "Disabled"}
                    </span>
                  </label>
                </div>
                {checkOutStatus ? (
                  <>
                    <Card className="backdrop-blur-xl bg-white/60 shadow-md rounded-3xl border border-gray-200">
                      <div className="p-8">
                        <div className="animate-fadeIn">

                          {/* Business Section */}
                          <div className="mb-8">
                            <div className="flex items-center gap-3 mb-5">
                              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
                                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                </svg>
                              </div>
                              <h5 className="text-lg font-semibold text-gray-800">Business Information</h5>
                            </div>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                              <div className="space-y-5">
                                <InputField
                                  variant="auth"
                                  extra="w-full"
                                  label="Name"
                                  placeholder="Enter Value"
                                  id="business_name"
                                  type="text"
                                  value={businessName}
                                  onChange={handleBusinessChange}
                                />
                                <InputField
                                  variant="auth"
                                  extra="w-full"
                                  label="Logo"
                                  placeholder="Choose Logo"
                                  id="business_logo"
                                  type="file"
                                  onChange={handleFileChange}
                                />
                              </div>
                              
                              <div className="w-full">
                                <label className="block text-sm font-medium text-gray-700 mb-1.5">Logo Preview</label>
                                <div className="h-full h-[140px] p-6 bg-gradient-to-br from-indigo-50 to-purple-50 rounded-lg border border-indigo-100 flex items-center justify-center">
                                  {imagePreview ? (
                                    <img 
                                      src={imagePreview} 
                                      alt="Logo Preview" 
                                      className="max-h-full max-w-full object-contain"
                                    />
                                  ) : (
                                    <span className="text-sm text-gray-400">No logo selected</span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          
                          {/* Style Section */}
                          <div className="border-t border-gray-200 pt-8 mb-8">
                            <div className="flex items-center gap-3 mb-5">
                              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-pink-600 flex items-center justify-center">
                                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
                                </svg>
                              </div>
                              <h5 className="text-lg font-semibold text-gray-800">Style Configurations</h5>
                            </div>
                            
                            <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
                              <div className="bg-gradient-to-br from-indigo-50 to-purple-50 p-5 rounded-2xl border border-indigo-100">
                                <label htmlFor="style" className="block text-sm font-medium text-gray-700 mb-3">
                                  Border Style
                                </label>
                                <select 
                                  id="style" 
                                  className="w-full px-4 py-2.5 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200 outline-none cursor-pointer"
                                  onChange={handleStyleChange}
                                >
                                  <option value="rounded" selected={style === 'rounded'}>Rounded</option>
                                  <option value="sharp" selected={style === 'sharp'}>Sharp</option>
                                  <option value="pill" selected={style === 'pill'}>Pill</option>
                                </select>
                                
                                <div className="mt-4">
                                  <span className="text-xs text-gray-600 font-medium mb-2 block">Preview</span>
                                  <input
                                    type="text"
                                    className={`border-2 p-3 w-full ${getBorderRadiusClass()} border-indigo-500 bg-white shadow-sm text-gray-700 font-medium`}
                                    disabled
                                    value='Preview'
                                  />
                                </div>
                              </div>

                              <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-5 rounded-2xl border border-purple-100">
                                <label htmlFor="font" className="block text-sm font-medium text-gray-700 mb-3">
                                  Typography
                                </label>
                                <select 
                                  id="font" 
                                  className="w-full px-4 py-2.5 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200 outline-none cursor-pointer"
                                  onChange={handleFontChange}
                                >
                                  <option value="'Poppins'" selected={selectedFont === "'Poppins'"}>Poppins</option>
                                  <option value="'DM Sans'" selected={selectedFont === "'DM Sans'"}>DM Sans</option>
                                  <option value="'circular'" selected={selectedFont === "'circular'"}>circular</option>
                                </select>
                                
                                <div className="mt-4 p-3 bg-white rounded-lg border border-purple-200">
                                  <span className="text-xs text-gray-600 font-medium mb-2 block">Preview</span>
                                  <label 
                                    style={{ fontFamily: selectedFont, fontSize: '18px' }} 
                                    className="text-gray-800 font-medium"
                                  >
                                    Font Preview
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Brand Color Section */}
                          <div className="border-t border-gray-200 pt-8 mb-8">
                            <div className="flex items-center gap-3 mb-5">
                              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-pink-500 to-orange-600 flex items-center justify-center">
                                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
                                </svg>
                              </div>
                              <h5 className="text-lg font-semibold text-gray-800">Brand Colors</h5>
                            </div>
                            
                            <p className="text-sm text-gray-600 mb-6">Choose primary and secondary colors to create your brand gradient</p>
                            
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Primary Color</label>
                                <div className="relative">
                                  <div 
                                    className="flex items-center gap-3 p-3 bg-white border border-gray-300 rounded-lg cursor-pointer hover:border-indigo-400 transition-colors"
                                    onClick={() => setShowPrimaryPicker(!showPrimaryPicker)}
                                  >
                                    <div 
                                      className="w-10 h-10 rounded-lg border-2 border-gray-200 shadow-sm"
                                      style={{ backgroundColor: primaryColor }}
                                    />
                                    <span className="text-sm font-mono text-gray-700">{primaryColor}</span>
                                  </div>
                                  {showPrimaryPicker && (
                                    <div className="absolute z-10 mt-2">
                                      <div 
                                        className="fixed inset-0" 
                                        onClick={() => setShowPrimaryPicker(false)}
                                      />
                                      <SketchPicker 
                                        color={primaryColor}
                                        onChange={(color) => setPrimaryColor(color.hex)}
                                        disableAlpha={true}
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Secondary Color</label>
                                <div className="relative">
                                  <div 
                                    className="flex items-center gap-3 p-3 bg-white border border-gray-300 rounded-lg cursor-pointer hover:border-purple-400 transition-colors"
                                    onClick={() => setShowSecondaryPicker(!showSecondaryPicker)}
                                  >
                                    <div 
                                      className="w-10 h-10 rounded-lg border-2 border-gray-200 shadow-sm"
                                      style={{ backgroundColor: secondaryColor }}
                                    />
                                    <span className="text-sm font-mono text-gray-700">{secondaryColor}</span>
                                  </div>
                                  {showSecondaryPicker && (
                                    <div className="absolute z-10 mt-2">
                                      <div 
                                        className="fixed inset-0" 
                                        onClick={() => setShowSecondaryPicker(false)}
                                      />
                                      <SketchPicker 
                                        color={secondaryColor}
                                        onChange={(color) => setSecondaryColor(color.hex)}
                                        disableAlpha={true}
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Button Color</label>
                                <div className="relative">
                                  <div 
                                    className="flex items-center gap-3 p-3 bg-white border border-gray-300 rounded-lg cursor-pointer hover:border-purple-400 transition-colors"
                                    onClick={() => setShowButtonPicker(!showButtonPicker)}
                                  >
                                    <div 
                                      className="w-10 h-10 rounded-lg border-2 border-gray-200 shadow-sm"
                                      style={{ backgroundColor: buttonColor }}
                                    />
                                    <span className="text-sm font-mono text-gray-700">{buttonColor}</span>
                                  </div>
                                  {showButtonPicker && (
                                    <div className="absolute z-10 mt-2">
                                      <div 
                                        className="fixed inset-0" 
                                        onClick={() => setShowButtonPicker(false)}
                                      />
                                      <SketchPicker 
                                        color={buttonColor}
                                        onChange={(color) => setButtonColor(color.hex)}
                                        disableAlpha={true}
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-2xl border border-gray-200">
                              <h6 className="text-sm font-semibold text-gray-700 mb-4">Preview</h6>
                              
                              <div 
                                className="h-32 rounded-xl mb-4 flex items-center justify-center shadow-lg"
                                style={{ 
                                  background: `linear-gradient(to right, ${primaryColor}, ${secondaryColor})` 
                                }}
                              >
                                <h3 className="text-2xl font-bold text-white drop-shadow-lg">Lightning Checks</h3>
                              </div>

                              <div className="flex gap-3">
                                <button 
                                  className="px-6 py-2.5 rounded-lg font-medium text-white shadow-md hover:shadow-lg transition-all"
                                  style={{ backgroundColor: buttonColor }}
                                >
                                  Primary Button
                                </button>
                                {/* <button 
                                  className="px-6 py-2.5 rounded-lg font-medium text-white shadow-md hover:shadow-lg transition-all"
                                  style={{ 
                                    background: `linear-gradient(to right, ${primaryColor}, ${secondaryColor})` 
                                  }}
                                >
                                  Gradient Button
                                </button> */}
                                {/* <button 
                                  className="px-6 py-2.5 rounded-lg font-medium border-2 bg-white shadow-sm hover:shadow-md transition-all"
                                  style={{ 
                                    borderColor: primaryColor,
                                    color: primaryColor
                                  }}
                                >
                                  Outline Button
                                </button> */}
                              </div>
                            </div>
                          </div>

                          {/* Button Section*/}
                          <div className="border-t border-gray-200 pt-8">
                            <div className="mt-5 flex w-full justify-end">
                              <div className="flex gap-2">
                                <button
                                  onClick={handleClose}
                                  className="linear rounded-xl bg-red-50 px-5 py-2 text-base font-medium text-red-500 outline-none transition duration-200 hover:bg-red-600/5 active:bg-red-700/5 dark:bg-red-400/10 dark:text-white dark:hover:bg-red-300/10 dark:active:bg-red-200/10"
                                >
                                  Close
                                </button>
                                <button
                                  className="linear rounded-xl bg-indigo-600 px-3 py-2 text-base font-medium text-white outline-none transition duration-200 hover:bg-indigo-600 active:bg-indigo-600 dark:bg-indigo-400/10 dark:text-white dark:hover:bg-indigo-300/10 dark:active:bg-indigo-200/10"
                                  onClick={handleFormSubmit}
                                >
                                  {isLoading ? (
                                      <DivLoader className="h-6 w-6 border-white" />
                                  ) : (
                                  <>{"Submit"}</>
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </Card>
                  </>
                ) : ( 
                  <>
                    <div className="overflow-auto text-center">
                        <div className="flex flex-col justify-center items-center px-2 h-full">
                            <img
                              src={smart_routingimg.default}
                              alt="smart_routing_img"
                              className={`w-[300px] ${checkOutStatus}`}
                              loading="lazy"
                            />
                          <h3 className="text-[20px] mb-2">Looks like checkout is disabled! Enable it now to set up and configure your checkout settings with ease.</h3>
                          <button
                            onClick={handleClose}
                            className="linear rounded-xl bg-indigo-600 px-5 py-2 text-white font-medium text-navy-700 outline-none transition duration-200 hover:bg-indigo-500 active:bg-indigo-500 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                          >
                            Close
                          </button>
                        </div>
                      </div>
                  </>
                )}
              </>
            )}
          </ModalBody>
        </Card>
      </Modal >
    </>
  );
};
export default CheckoutProductClientModal;